/**
 * Author: Satyam Sharma
 * Date: 3rd Feb 2025
 * Description: The UI needs to be changed.
 */
const AiThinking = () => {

  return (
    <div id='ele-278' className="main-container fade-in">
      <div id='ele-280' className={`rounded-xl py-3 px-5 max-w-80 bg-primaryBgColor relative rounded-bl-none mt-3 min-w-20 `}>
        <img className="h-5" src={process.env.REACT_APP_CDN + "/typing.gif"} alt="loading..." />
      </div>
    </div>
  );
};

export default AiThinking;